export const useDashboardConfig = () => {
  const elementContainer = document.querySelector<HTMLElement>('#dashboard-root');

  return {
    invoiceEndpoint: elementContainer?.dataset.invoiceEndpoint ?? '/api/invoices/overview',
    servicesEndpoint: elementContainer?.dataset.servicesEndpoint ?? '/api/services/jobs-summary',
    urlPayCta: elementContainer?.dataset.urlPayCta ?? '',
    urlInvoiceCta: elementContainer?.dataset.urlInvoiceCta ?? '',
    labels: {
      invoiceTitle: elementContainer?.dataset.labelInvoiceTitle ?? '',
      invoiceSubtitle: elementContainer?.dataset.labelInvoiceSubtitle ?? '',
      invoiceNone: elementContainer?.dataset.labelInvoiceNone ?? '',
      invoiceOtherOutstanding: elementContainer?.dataset.labelInvoiceOtherOutstanding ?? '',
      invoiceIssue: elementContainer?.dataset.labelInvoiceIssue ?? '',
      invoiceHistory: elementContainer?.dataset.labelInvoiceHistory ?? '',
      invoiceCta: elementContainer?.dataset.labelInvoiceCta ?? '',
      payButtonLabel: elementContainer?.dataset.labelPayButton ?? 'Pay',
      noServicesHeading: elementContainer?.dataset.labelNoServicesHeading ?? '',
      noServicesMessageHeading: elementContainer?.dataset.labelNoServicesMessageHeading ?? '',
      noServicesMessageText: elementContainer?.dataset.labelNoServicesMessageText ?? '',
      downloadsHeading: elementContainer?.dataset.downloadsHeading ?? '',
      downloadsExpiryText: elementContainer?.dataset.downloadsExpiryText ?? '',
      downloadsExpiryDateLabel: elementContainer?.dataset.downloadsExpiryDateLabel ?? '',
    },
    noServicesIconUrl: elementContainer?.dataset.noServicesIconUrl ?? '',
  };
};
